import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import { ProductProvider } from './contexts/ProductContext';
import { OrderProvider } from './contexts/OrderContext';
import { CategoryProvider } from './contexts/CategoryContext';
import { SettingsProvider } from './contexts/SettingsContext';
import Navbar from './components/Navbar';
import AdminLayout from './components/AdminLayout';
import WhatsAppButton from './components/WhatsAppButton';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Orders from './pages/Orders';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminProducts from './pages/AdminProducts';
import AdminOrders from './pages/AdminOrders';
import AdminSettings from './pages/AdminSettings';
import Account from './pages/Account';
import ToastProvider from './components/Toast';
import './App.css';

function App() {
  return (
    <ToastProvider>
      <CategoryProvider>
        <AuthProvider>
          <SettingsProvider>
            <ProductProvider>
              <CartProvider>
                <OrderProvider>
                  <Router>
                    <div className="App">
                      <Routes>
                        {/* Admin Routes - Only accessible via /admin URLs */}
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin/dashboard" element={
                          <AdminLayout>
                            <AdminDashboard />
                          </AdminLayout>
                        } />
                        <Route path="/admin/products" element={
                          <AdminLayout>
                            <AdminProducts />
                          </AdminLayout>
                        } />
                        <Route path="/admin/orders" element={
                          <AdminLayout>
                            <AdminOrders />
                          </AdminLayout>
                        } />
                        <Route path="/admin/settings" element={
                          <AdminLayout>
                            <AdminSettings />
                          </AdminLayout>
                        } />
                        
                        {/* Regular User Routes - No admin content visible */}
                        <Route path="/*" element={
                          <>
                            <Navbar />
                            <main className="main-content">
                              <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/login" element={<Login />} />
                                <Route path="/register" element={<Register />} />
                                <Route path="/products" element={<Products />} />
                                <Route path="/product/:id" element={<ProductDetail />} />
                                <Route path="/cart" element={<Cart />} />
                                <Route path="/checkout" element={<Checkout />} />
                                <Route path="/orders" element={<Orders />} />
                                <Route path="/account" element={<Account />} />
                              </Routes>
                            </main>
                            <WhatsAppButton />
                          </>
                        } />
                      </Routes>
                    </div>
                  </Router>
                </OrderProvider>
              </CartProvider>
            </ProductProvider>
          </SettingsProvider>
        </AuthProvider>
      </CategoryProvider>
    </ToastProvider>
  );
}

export default App; 